
/**
 * Scrolls to the first form error with animation
 * @param formElement The form or container element containing errors
 */
export const scrollToFirstError = (formElement: HTMLFormElement | HTMLDivElement | null) => {
  if (!formElement) return;
  
  // Find the first error message element
  const firstErrorElement = formElement.querySelector('[id^="form-error"], .form-error');
  
  if (firstErrorElement) {
    // Scroll to the error with some offset to make it visible
    firstErrorElement.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  }
};
